import getStaticElement from '../accessors/get-static-element';
import findBlockSettingComments from '../utils/helpers/find-block-setting-comments';

const areChildrenEnabled = (containerId, childrenSelector) => {
  const container = getStaticElement(containerId);

  if (container && container.querySelector(childrenSelector)) {
    return true;
  }

  if (findBlockSettingComments(container, childrenSelector).length > 0) {
    return false;
  }

  return null;
};

export default areChildrenEnabled;
